<div class="restricted-width">
  <div class="page-title"><b>Llámanos |</b> Ingresar un Llámanos</div>
  <hr class="page-title-hr" />
  @if (!showFormulario) {
    <div class="filters-container">
      @if (isArcoprime) {
        <div class="filter-container">
          <div class="filter-title required">ID PAGADOR</div>
          <div class="filter">
            <ng-select
              [items]="pagadores"
              bindLabel="label"
              bindValue="id_pagador"
              [(ngModel)]="selectedPagador"
              (ngModelChange)="onPagadorChange($event)"
              [clearable]="false"
              [searchable]="true"
              placeholder="Seleccionar"
            />
          </div>
        </div>
      }
      <div class="filter-container">
        <div class="filter-title required">ESTACIÓN DE SERVICIO</div>
        <div class="filter">
          <ng-select
            [items]="edsOptions"
            bindLabel="label"
            bindValue="value"
            [(ngModel)]="selectedEstacion"
            (ngModelChange)="onEstacionChange($event)"
            [clearable]="false"
            [searchable]="false"
            placeholder="Seleccionar"
          />
        </div>
      </div>
      <div class="filter-container filter-container--categoria">
        <div class="filter-title required">CATEGORÍA</div>
        <div class="filter">
          <ng-select
            [items]="categoriasOptions"
            bindLabel="label"
            bindValue="value"
            [(ngModel)]="selectedCategoria"
            (ngModelChange)="onCategoriaChange($event)"
            [clearable]="false"
            [searchable]="false"
            placeholder="Seleccionar"
          />
        </div>
      </div>
      <div class="filter-container filter-container--categoria">
        <div class="filter-title required">SUBCATEGORÍA</div>
        <div class="filter">
          <ng-select
            [items]="subcategoriasOptions"
            bindLabel="label"
            bindValue="value"
            [(ngModel)]="selectedSubcategoriaKey"
            (ngModelChange)="onSubcategoriaChange($event)"
            [clearable]="false"
            [searchable]="false"
            placeholder="Seleccionar"
          />
        </div>
      </div>
      <div class="filter-container">
        <button
          [disabled]="!selectedSubcategoriaKey || !selectedEstacion"
          (click)="setShowFormulario(true)"
        >
          Continuar
        </button>
      </div>
    </div>

    <div class="importante">
      <span class="importante-title">Importante: </span>
      Si consideras que tu problema no se ajusta a ninguna categoría, por favor
      contáctanos a través de nuestro Contact Center, escribenos por WhatsApp o
      envíanos un correo.
    </div>
  }
  @if (showFormulario) {
    <div style="margin-top: 16px">
      <app-formulario
        [subcategoria]="selectedSubcategoria"
        [categoria]="selectedCategoria"
        categoriaType="Llámanos"
        [selectedEstacion]="selectedEstacionComplete"
        (closeFormulario)="setShowFormulario(false)"
        (finish)="finish($event)"
      >
      </app-formulario>
    </div>
  }
</div>
